import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { EyeIcon, SmileIcon, FrownIcon, DropletsIcon, ActivityIcon } from 'lucide-react';
export function WRTargetAreas() {
  const areas = [{
    name: 'Crows Feet',
    icon: EyeIcon
  }, {
    name: 'Forehead Lines',
    icon: ActivityIcon
  }, {
    name: 'Frown Lines',
    icon: FrownIcon
  }, {
    name: 'Chin Dimpling',
    icon: SmileIcon
  }, {
    name: 'Hyperhidrosis',
    icon: DropletsIcon
  }, {
    name: 'Vertical Lip Lines',
    icon: SmileIcon
  }, {
    name: 'Neck Wrinkles',
    icon: ActivityIcon
  }];
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-2378">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-2379">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-2380">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-2381">
            WHAT ARE THE TARGET AREAS?
          </h2>

          <p className="font-serif italic text-[#B0B0B0] text-[17px] mb-6" data-id="element-2382">
            Botox, Dysport and Xeomin can treat a wide variety of areas,
            including:
          </p>

          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-2383"></div>
        </AnimateOnScroll>

        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-[1000px] mx-auto" data-id="element-2384">
          {areas.map((area, index) => <AnimateOnScroll key={index} delay={index * 100} data-id="element-2385">
              <div className="bg-[#111111] p-8 rounded-lg flex flex-col items-center justify-center text-center h-full group hover:shadow-[0_4px_20px_rgba(255,20,147,0.15)] transition-all duration-300 border-b-2 border-transparent hover:border-[#FF1493]" data-id="element-2386">
                <area.icon size={40} strokeWidth={1.5} className="text-[#FF1493] mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-2387" />
                <h3 className="text-white text-base font-bold uppercase tracking-[1px] font-[Poppins,_sans-serif]" data-id="element-2388">
                  {area.name}
                </h3>
              </div>
            </AnimateOnScroll>)}
        </div>
      </div>
    </section>;
}